var _circle, _path, _path2, _g, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKefu1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#3D6BF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9839 10.3984L19.9822 10.3984C19.5231 10.4016 19.0644 10.5199 18.6524 10.7536L18.6524 10.7536L12.1036 14.4686C11.2682 14.9425 10.7515 15.8197 10.7515 16.7715V24.2018C10.7515 25.1535 11.2682 26.0307 12.1035 26.5044C12.1035 26.5044 12.1035 26.5044 12.1035 26.5044L18.6533 30.2199L18.7766 30.0024L18.6533 30.2199C19.4879 30.6933 20.5159 30.6933 21.3504 30.2199L27.8993 26.5054C28.7348 26.0316 29.2515 25.1542 29.2515 24.2025V16.7714C29.2515 15.8197 28.7347 14.9425 27.8993 14.4686L21.3501 10.7536C21.3501 10.7536 21.3501 10.7536 21.3501 10.7536C20.9382 10.5199 20.4793 10.4016 20.0203 10.3984V10.3984H20.0186L19.9839 10.3984Z",
    fill: "url(#paint0_linear_24_2364)",
    stroke: "white",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_24_2364",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 10,
    width: 19,
    height: 21
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9839 10.6484C19.5666 10.6513 19.1499 10.7589 18.7757 10.971L12.227 14.6861C11.4685 15.1163 11.0015 15.9112 11.0015 16.7715V24.2018C11.0015 25.062 11.4685 25.8569 12.2268 26.287L18.7766 30.0024C19.5348 30.4325 20.469 30.4325 21.227 30.0024L27.776 26.288C28.5344 25.8578 29.0015 25.0627 29.0015 24.2025V16.7714C29.0015 15.9112 28.5344 15.1163 27.776 14.6861L21.2268 10.971C20.8528 10.7589 20.4359 10.6513 20.0186 10.6484H19.9839Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_24_2364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9839 9.64844V9.64841L19.9771 9.64846C19.3927 9.65246 18.808 9.80313 18.2825 10.1012L18.2823 10.1012L11.7336 13.8162C11.7336 13.8163 11.7336 13.8163 11.7335 13.8163C10.6672 14.4212 10.0015 15.5453 10.0015 16.7715V24.2018C10.0015 25.4278 10.6671 26.552 11.7334 27.1568C11.7335 27.1568 11.7335 27.1568 11.7335 27.1568L18.2832 30.8722L18.2832 30.8722C19.3474 31.4758 20.6563 31.4759 21.7204 30.8723C21.7204 30.8722 21.7205 30.8722 21.7205 30.8722L28.2693 27.1578C29.3358 26.5529 30.0015 25.4286 30.0015 24.2025V16.7714C30.0015 15.5453 29.3357 14.4211 28.2693 13.8162L21.7202 10.1012C21.7202 10.1012 21.7202 10.1012 21.7201 10.1012C21.1946 9.80308 20.6097 9.65246 20.0254 9.64846L20.0254 9.64844H20.0186H19.9839Z",
    fill: "url(#paint1_linear_24_2364)",
    stroke: "white",
    strokeWidth: 2
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0852 24.1788L24.5165 23.9345L26.3844 22.8751C26.5571 22.777 26.7733 22.8997 26.7733 23.0958V23.6373C26.7733 24.0674 26.5398 24.4647 26.1609 24.6798L25.2953 25.1712L24.5165 25.6128L23.0381 26.4513L22.2591 26.8929L21.56 27.2885L20.7811 27.73C20.435 27.9266 20.0024 27.6813 20.0024 27.2885V21.1851C20.0024 20.7555 20.2352 20.3586 20.6135 20.1433L20.7813 20.0477L22.2591 19.2092L23.0381 18.7676L24.5165 17.9287L25.2953 17.4869L26.2087 16.9687C26.4597 16.8264 26.7733 17.0043 26.7733 17.2891V18.071C26.7733 18.286 26.6566 18.4846 26.4671 18.5922L25.2953 19.2572L24.5165 19.6988L23.8172 20.0944L23.0381 20.5361L22.2594 20.9782L21.56 21.3737V22.6102L26.5426 19.7824C26.6448 19.7244 26.7723 19.7968 26.7723 19.9127V21.155C26.7723 21.2625 26.714 21.362 26.6192 21.4157L21.5591 24.2861V25.6096L22.2583 25.214L23.0372 24.7721L24.0852 24.1788ZM20.3139 15.3653C20.2191 15.3116 20.1023 15.3116 20.0075 15.3653L19.2235 15.8099L18.4448 16.2521L17.7454 16.6475L16.9665 17.0896L15.7948 17.7541C15.6053 17.8617 15.4884 18.0604 15.4884 18.2754V25.263C15.4884 25.4782 15.6053 25.6769 15.7949 25.7845L16.2675 26.0522L16.617 26.2501C16.7726 26.3381 16.9667 26.2278 16.9667 26.0514V19.1142C16.9667 18.8992 17.0835 18.7004 17.2731 18.593L17.7457 18.3248L18.4451 17.9292L19.2238 17.4873L20.0026 17.0457L20.7813 16.6038L21.4094 16.2477C21.5115 16.1896 21.5115 16.0449 21.4094 15.9869L20.3139 15.3653ZM19.2228 20.9324V20.3964C19.2228 20.1814 19.3396 19.9826 19.529 19.8752L20.0016 19.6072L20.7803 19.1651L22.2584 18.3269L23.0373 17.8853L24.5157 17.0467L25.2945 16.6048C25.6048 16.4292 25.6048 15.9893 25.2945 15.8137L25.2148 15.7687L24.5157 15.3732L23.737 14.9313L23.3873 14.7336L23.0373 14.5357L22.9581 14.4906L21.4797 13.6522L20.7803 13.2568L20.6138 13.1622C20.2349 12.9472 19.7681 12.947 19.389 13.1616L13.8444 16.3017C13.4648 16.5168 13.231 16.9144 13.231 17.3448V23.6369C13.231 24.0668 13.4643 24.4642 13.8433 24.6793L14.0093 24.7736L14.2491 24.9098C14.4534 25.0256 14.7087 24.8809 14.7087 24.6492V17.8359C14.7087 17.6208 14.8255 17.4221 15.015 17.3145L20.0016 14.486L20.1626 14.577L20.7803 14.9276L22.382 15.8363L23.0367 16.2082L22.2584 16.649L20.7806 17.4874L20.0019 17.9293L19.2228 18.3726L18.4441 18.8148L18.0518 19.0367C17.8619 19.1441 17.7447 19.3431 17.7447 19.5584V26.6314C17.7447 26.7928 17.8326 26.9421 17.9751 27.0225L18.4441 27.288L18.5238 27.3328C18.8347 27.5087 19.2228 27.2883 19.2228 26.9358V20.9324Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24_2364",
    x1: 10.7359,
    y1: 10.7936,
    x2: 11.0532,
    y2: 30.4693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F23DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466245,
    stopColor: "#9922D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C28DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_24_2364",
    x1: 10.7359,
    y1: 10.7936,
    x2: 11.0532,
    y2: 30.4693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F23DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466245,
    stopColor: "#9922D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C28DD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKefu1);
export default __webpack_public_path__ + "static/media/kefu1.b730b20019c6234a840f18a501206151.svg";
export { ForwardRef as ReactComponent };